export class NewCommentItem {
  public OrderId: number
  public ModelId: number;
  public ColorId: number;
  public SizeGroupId: number;
  public ImgPath: string;
  public Text: string;

  constructor(init?: Partial<NewCommentItem>) {
    Object.assign(this, init);
  }
}
